module.exports = __webpack_public_path__ + "static/img/illustrator1@2x.992e218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illustrator1@2x.png
// module id = 8BSN
// module chunks = 1